import React, { FC } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import { useAppSelector } from '@hooks/redux-custom';
import { isoStringToLegibleString } from '@helpers';

type Props = {
  handleBack: () => void;
  handleNext: () => void;
};

export const DetailConfirmation: FC<Props> = ({ handleBack, handleNext }) => {
  const { deliveryTime, recipient, shippingAddress } = useAppSelector((state) => state.order.value);

  const renderRecipientDetails = () => {
    if (recipient.type === 'OnlyCustomer' || recipient.type === 'SomeoneElse') {
      return (
        <Typography variant="body1" data-testid="confirm-recipient-text">
          {recipient.first_name} {recipient.last_name}
          <br />
          <PhoneAndroidOutlinedIcon /> {recipient.phone}
        </Typography>
      );
    }

    if (recipient.type === 'AnyAdult') {
      return <Typography variant="body1">Any adult at the address may accept this delivery.</Typography>;
    }
  };

  const renderDeliveryTime = () => {
    if (deliveryTime.type === 'FutureOrder') {
      return (
        <Box data-testid="confirm-delivery-time-text">
          <Typography variant="body1">Between:</Typography>
          <Typography variant="body1">{isoStringToLegibleString(deliveryTime.requested_delivery_time)} -</Typography>
          <Typography variant="body1">{isoStringToLegibleString(deliveryTime.requested_delivery_end_time)}</Typography>
        </Box>
      );
    }

    if (deliveryTime.type === 'ASAP') {
      return <Typography variant="body1">As soon as possible</Typography>;
    }
  };

  return (
    <>
      <Grid container columnSpacing={6} marginY={4} justifyContent="center" px={2}>
        <Grid item flex={1}>
          <Typography variant="h6">Shipping Address:</Typography>
          <Typography variant="body1" data-testid="confirm-address-text">
            {shippingAddress?.company && (
              <>
                {shippingAddress?.company} <br />
              </>
            )}
            {shippingAddress?.address2 ? `${shippingAddress?.address1}, ${shippingAddress?.address2}` : shippingAddress?.address1}
            <br />
            {shippingAddress?.city}
            <br />
            {shippingAddress?.state_or_province} {shippingAddress?.postal_code}
            <br />
            {shippingAddress?.country}
          </Typography>
        </Grid>
        <Grid item flex={1}>
          <Typography variant="h6">Recipient:</Typography>
          {renderRecipientDetails()}
        </Grid>
        <Grid item flex={1}>
          <Typography variant="h6">Delivery Time:</Typography>
          {renderDeliveryTime()}
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', pt: 2 }}>
        <Button onClick={handleBack} sx={{ mr: 1 }} data-testid="confirm-back-btn">
          Back
        </Button>
        <Button onClick={handleNext} data-testid="confirm-btn">
          Confirm
        </Button>
      </Box>
    </>
  );
};
